import { useFormErrors } from 'vee-validate';
import { computed } from 'vue';
import type { AdresFieldPaths } from './types';
import { getAdresFieldPaths } from './utils';

export const useAdresFieldProps = (path: string | null = 'adres') => {
  const formErrors = useFormErrors();

  const adresFieldPaths: AdresFieldPaths = getAdresFieldPaths(path ?? undefined);

  const errors = computed<string[]>(() =>
    Object.entries(formErrors.value)
      .filter(([fieldPath]) => Object.values(adresFieldPaths).includes(fieldPath))
      .map(([, errorMessage]) => errorMessage ?? ''),
  );

  return {
    adresFieldPaths,
    errors,
  };
};
